import React from 'react'

const MatchIcon = () => (
	<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="48" height="48" rx="24" fill="#75C3AC"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M20.4468 30C20.2357 30 20.0232 29.9199 19.8589 29.761L15.263 25.3228C14.923 24.9951 14.9117 24.4527 15.2347 24.1092C15.5605 23.7657 16.0975 23.7542 16.4375 24.082L20.4483 27.9548L30.5637 18.237C30.9037 17.9092 31.4421 17.9235 31.7665 18.267C32.0895 18.6105 32.0753 19.1544 31.7367 19.4807L21.0334 29.7624C20.869 29.9213 20.6579 30 20.4468 30Z" fill="white"/>
	</svg>
) 

export default MatchIcon